import { getCropAspectRatio } from './cropAspectRatios';

export { getCropAspectRatio };

/**
 * Largest centered crop (w/h = aspect) that fits inside the source image.
 */
export function maxCropSizeForAspect(naturalWidth, naturalHeight, aspectWOverH) {
  if (!naturalWidth || !naturalHeight || !aspectWOverH) {
    return null;
  }
  if (naturalWidth / naturalHeight >= aspectWOverH) {
    return {
      width: Math.max(1, Math.round(naturalHeight * aspectWOverH)),
      height: naturalHeight,
    };
  }
  return {
    width: naturalWidth,
    height: Math.max(1, Math.round(naturalWidth / aspectWOverH)),
  };
}

export function heightFromCropWidth(width, aspectWOverH) {
  const w = Number(width);
  if (!Number.isFinite(w) || w < 1 || !aspectWOverH) return null;
  return Math.max(1, Math.round(w / aspectWOverH));
}

export function widthFromCropHeight(height, aspectWOverH) {
  const h = Number(height);
  if (!Number.isFinite(h) || h < 1 || !aspectWOverH) return null;
  return Math.max(1, Math.round(h * aspectWOverH));
}

/**
 * Clamp crop pixel size to source bounds while keeping a fixed aspect (w/h).
 * @param {'width'|'height'} [driver] - which axis the user last edited
 */
export function clampCropDimensionsForAspect(
  width,
  height,
  aspectWOverH,
  naturalWidth,
  naturalHeight,
  driver = 'width',
) {
  if (!aspectWOverH) return null;

  let w = Math.round(Number(width));
  let h = Math.round(Number(height));

  if (driver === 'height') {
    if (!Number.isFinite(h) || h < 1) return null;
    w = widthFromCropHeight(h, aspectWOverH);
    if (w == null) return null;
  } else {
    if (!Number.isFinite(w) || w < 1) return null;
    h = heightFromCropWidth(w, aspectWOverH);
    if (h == null) return null;
  }

  if (typeof naturalWidth === 'number' && typeof naturalHeight === 'number') {
    const maxSize = maxCropSizeForAspect(naturalWidth, naturalHeight, aspectWOverH);
    if (maxSize) {
      if (w > maxSize.width) {
        w = maxSize.width;
        h = maxSize.height;
      }
      if (h > maxSize.height) {
        h = maxSize.height;
        w = maxSize.width;
      }
    }
    w = Math.min(w, naturalWidth);
    h = Math.min(h, naturalHeight);
  }

  w = Math.max(1, w);
  h = Math.max(1, h);
  return { width: w, height: h };
}
